import { Component, h } from 'preact';
import { Properties } from '../../common/types';
import { withStyles, WithStyles } from '../../style';
import { NBSP } from '../constants';
import * as styles from './Loader.scss';

export enum LoaderColor {
  BLUE = 'blue',
  GREY = 'grey',
}

interface LoaderProps extends Properties {
  absolute?: boolean;
  center?: boolean;
  wrapper?: boolean;
  color?: LoaderColor;
}

type EffectiveProps = LoaderProps & WithStyles;

@withStyles(styles)
class Loader extends Component<LoaderProps, any> {
  render({ absolute, center, color, tx, wrapper = true }: EffectiveProps) {
    return (
      <div class={tx(this.props.class, { absolute, wrapper })}>
        <div class={tx('loader', { greyTheme: color === LoaderColor.GREY, center })}>{NBSP}</div>
      </div>
    );
  }
}

export default Loader;
